import {
  BookingEventSetupState,
  INITIAL_BOOKING_EVENT_SETUP_STATE,
} from '@deltager/organizers/admin/modules/booking-event-setup/store/booking-event-setup.state';
import { Action } from '@ngrx/store';
import {
  AdjustDocumentPropertiesAction,
  BookingEventActionTypes,
  BookingEventModifyAction,
  BookingEventStatusChangeAction,
  ChangeBookingStepAction,
  ConstructBookingEventSuccessAction,
  UpdateAutomaticPublishAction,
  UpdateBookingEventSuccessAction,
} from './booking-event-setup.actions';
import { BookingEvent } from '@deltager/organizers/admin/shared/models/booking-event.model';
import _ from 'lodash';

export const bookingEventSetupReducer = (
  state: BookingEventSetupState = INITIAL_BOOKING_EVENT_SETUP_STATE,
  action: Action,
): BookingEventSetupState => {
  switch (action.type) {
    case BookingEventActionTypes.BookingEventModify: {
      const modifiedBookingEvent = (action as BookingEventModifyAction).payload.bookingEvent;

      return Object.assign({}, state, {
        bookingEvent: modifiedBookingEvent,
      });
    }
    case BookingEventActionTypes.ConstructBookingEventSuccess: {
      const constructedBookingEvent = (action as ConstructBookingEventSuccessAction).payload.bookingEvent;

      return Object.assign({}, state, {
        bookingEvent: constructedBookingEvent,
      } as BookingEventSetupState);
    }
    case BookingEventActionTypes.PublishBookingEventSuccess:
    case BookingEventActionTypes.LoadBookingEventSuccess:
    case BookingEventActionTypes.CreateBookingEventSuccess: {
      const createdBookingEvent = _.cloneDeep((action as any).payload.bookingEvent as BookingEvent);

      // document properties saving to store in another action
      createdBookingEvent.documents = state.bookingEvent?.documents ?? [];
      createdBookingEvent.documentUrls = state.bookingEvent?.documentUrls ?? [];

      return Object.assign({}, state, {
        initialEvent: createdBookingEvent,
        bookingEvent: createdBookingEvent,
        currentStep: createdBookingEvent.bookingSetupStep,
      } as BookingEventSetupState);
    }
    case BookingEventActionTypes.UpdateBookingEventSuccess: {
      const updatedBookingEvent = (action as UpdateBookingEventSuccessAction).payload.bookingEvent;

      return Object.assign({}, state, {
        initialEvent: updatedBookingEvent,
        bookingEvent: updatedBookingEvent,
      } as BookingEventSetupState);
    }
    case BookingEventActionTypes.BookingEventStatusChange: {
      const changedBookingEvent = (action as BookingEventStatusChangeAction).payload.bookingEventStatus;

      return Object.assign({}, state, {
        bookingEventSetupStatus: changedBookingEvent,
      } as BookingEventSetupState);
    }
    case BookingEventActionTypes.AdjustDocumentProperties: {
      const documentUrls = (action as AdjustDocumentPropertiesAction).payload.documentUrls;

      return Object.assign({}, state, {
        initialEvent: {
          ...state.initialEvent,
          documents: [],
          documentUrls: documentUrls,
        },
        bookingEvent: {
          ...state.bookingEvent,
          documents: [],
          documentUrls: documentUrls,
        },
      } as BookingEventSetupState);
    }

    case BookingEventActionTypes.UpdateAutomaticPublish: {
      const automaticPublish = (action as UpdateAutomaticPublishAction).automaticPublish;

      return Object.assign({}, state, {
        automaticPublish,
      } as BookingEventSetupState);
    }

    case BookingEventActionTypes.ChangeBookingEventStep: {
      return Object.assign({}, state, {
        currentStep: (action as ChangeBookingStepAction).payload.step,
      } as BookingEventSetupState);
    }

    case  BookingEventActionTypes.ClearBookingEventStore: {
      return INITIAL_BOOKING_EVENT_SETUP_STATE;
    }

    default: {
      return state;
    }
  }
};
